import APIClient from '@/shared/http/clients/api'

const resourceName = 'relatorio/visitas/deslocamento'
const APICore = process.env.APIBaseURLCore

const GetAllDeslocamento = (filters, limit, index, config = {}) => APIClient.post(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, filters, config)
const GetPdf = (filters, config = {}) => APIClient.post(`${APICore}/${resourceName}/export`, filters, config)

const ReportVisitasRepository = {
  GetAllDeslocamento,
  GetPdf
}

export default ReportVisitasRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/deslocamento/report.js